import { RouterView } from '@/models/enums';
import { Route } from 'vue-router';
import router from '@/router/router';

class RouterHelper {
  navigateToHomeView(inNewTab: boolean = false): Promise<Route | void> {
    if (inNewTab) {
      window.open(router.resolve({ name: RouterView.Home }).href, '_blank');
      return Promise.resolve();
    }
    if (router.currentRoute.name === RouterView.Home) {
      return Promise.resolve(router.currentRoute);
    }
    return router.push({ name: RouterView.Home }).catch(_ => {});
  }

  navigateToNotifications(): Promise<Route | void> {
    if (router.currentRoute.name === RouterView.Notifications) {
      return Promise.resolve(router.currentRoute);
    }
    return router.push({ name: RouterView.Notifications });
  }
}

export const routerHelper: RouterHelper = new RouterHelper();
